import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxTabsModule, DxTabsTypes } from 'devextreme-angular/ui/tabs';
import { PanelItem, Dates } from '../../resource';
import { ScreenService } from '../../screen.service';
import { DxToolbarModule, DxButtonModule } from 'devextreme-angular';

@Component({
  selector: 'dk-toolbar-dashboard',
  standalone: true,
  imports: [CommonModule, DxToolbarModule, DxTabsModule, DxButtonModule],
  templateUrl: './toolbar-dashboard.component.html',
  styleUrls: ['./toolbar-dashboard.component.scss'],
})
export class ToolbarDashboardComponent {
  @Input() titleText: string;
  @Input() panelItems: Array<PanelItem>;
  @Input() selectedItems: Array<number>;

  @Output() selectionChanged = new EventEmitter<Dates>();

  constructor(protected screen: ScreenService) {}

  selectionChange(e: DxTabsTypes.ItemClickEvent) {
    const dates = e.itemData.value.split('/');

    this.selectionChanged.emit({ startDate: dates[0], endDate: dates[1] });
  }
}
